class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.throttleId = null;
  }

  connectedCallback() {
    this.currentScrollTop = 0;
    this.headerHeight = 0;

    this.stickyType = this.getAttribute('data-sticky-type');

    // Recalculate height after layout to account for announcement bars or images
    requestAnimationFrame(() => {
      this.headerHeight = this.offsetHeight;
    });

    this.onScroll = this.onScroll.bind(this);
    const throttledScroll = () => {
      if (this.throttleId) return;
      this.onScroll();
      this.throttleId = setTimeout(() => { this.throttleId = null; }, 16);
    };
    window.addEventListener('scroll', throttledScroll, { passive: true });

    // Ensure header is visible when tabbing into it
    this.addEventListener('focusin', () => {
      this.reveal();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  reveal() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Only add the sticky (fixed) class if we aren't at the very top
    if (scrollTop > this.headerHeight) {
      this.classList.add('shopify-section-header-sticky');
    }

    this.classList.remove('shopify-section-header-hidden');
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop < 0 || scrollTop === this.currentScrollTop) return; // Prevent iOS bounce and redundant checks

    // ALWAYS stick (no hide)
    if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
      this.classList.remove('shopify-section-header-hidden');
      this.classList.add('shopify-section-header-sticky');
      return;
    }

    // SCROLL UP BEHAVIOR
    if (this.stickyType === 'on-scroll-up') {
      if (scrollTop <= this.headerHeight) {
        // At top of page - back to normal flow
        this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
        // Scrolling down - hide the header
        this.classList.add('shopify-section-header-hidden');
      } else if (scrollTop < this.currentScrollTop) {
        // Scrolling up - reveal the header and keep it sticky
        this.classList.add('shopify-section-header-sticky', 'animate');
        this.classList.remove('shopify-section-header-hidden');
      }
    }

    this.currentScrollTop = scrollTop;
  }
}

customElements.define('sticky-header', StickyHeader);